"use strict";

var _classCallCheck = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _get = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _getPrototypeOf = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Med Poc\\med-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Repulse = void 0;

var RepulseDiv_1 = require("./RepulseDiv");

var RepulseBase_1 = require("./RepulseBase");

var Repulse = /*#__PURE__*/function (_RepulseBase_1$Repuls) {
  _inherits(Repulse, _RepulseBase_1$Repuls);

  var _super = _createSuper(Repulse);

  function Repulse() {
    _classCallCheck(this, Repulse);

    return _super.apply(this, arguments);
  }

  _createClass(Repulse, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(Repulse.prototype), "load", this).call(this, data);

      if ((data === null || data === void 0 ? void 0 : data.divs) === undefined) {
        return;
      }

      if (data.divs instanceof Array) {
        this.divs = data.divs.map(function (s) {
          var tmp = new RepulseDiv_1.RepulseDiv();
          tmp.load(s);
          return tmp;
        });
      } else {
        if (this.divs instanceof Array || !this.divs) {
          this.divs = new RepulseDiv_1.RepulseDiv();
        }

        this.divs.load(data.divs);
      }
    }
  }]);

  return Repulse;
}(RepulseBase_1.RepulseBase);

exports.Repulse = Repulse;